/**
 * Native HTML5 drag payload for Library files dragged out of chrome that
 * lives OUTSIDE the app-wide dnd-kit provider (e.g. the docked Add-from-
 * Library dialog). The data is the file record id; the canvas board's native
 * drop path resolves it into a reference at the cursor. dnd-kit drags never
 * populate dataTransfer, so the two channels can't collide.
 */
export const LIBRARY_FILE_DRAG_MIME = "application/x-cohesive-library-file";

/**
 * Companion payload for Library FOLDER drags from the same chrome. The data
 * is JSON: `{ workspaceId, path, name }` — the canvas drop resolves the
 * folder's descendant files and lands them as a section of references.
 */
export const LIBRARY_FOLDER_DRAG_MIME = "application/x-cohesive-library-folder";

export interface LibraryFolderDragPayload {
  workspaceId: string;
  path: string;
  name: string;
}
